import { KeyValuePair } from "src/connections/types";

export const findSecret = (secrets: KeyValuePair[], key: string) => {
  return secrets.find((s) => s.key === key);
};

export const getDefaultSecret = (
  key: string,
  env: string | null,
): KeyValuePair => ({
  key,
  value: "",
  required: true,
  secret: false,
  environment: env,
});

export const setSecretEnv = (
  secret: KeyValuePair,
  env: string | null,
): KeyValuePair => {
  return { ...secret, environment: env };
};

export const setSecretDeleted = (secret: KeyValuePair): KeyValuePair => {
  return { ...secret, value: null };
};

export const filterUpdatedSecrets = (pairs: KeyValuePair[] = []) => {
  // remove secrets for update but keep them for delete.
  return pairs.filter(
    (pair) => pair.key.trim() !== "" && (!pair.secret || pair.value === null),
  );
};

export const markSecrets = (secrets: KeyValuePair[] = []) =>
  secrets.map((pair) => ({ ...pair, secret: true }));

export const filterSecretsByEnvironment = (
  secrets: KeyValuePair[] = [],
  environment: string | null,
): KeyValuePair[] => secrets.filter((s) => s.environment === environment);
